import { type FC } from 'react';

import { Link } from 'react-router-dom';

import { PROJECTS } from '@entities/project';

import { ProjectCard } from './ProjectCard';
import styles from './ProjectsSection.module.css';

export const ProjectsSection: FC = () => {
  const [featured, ...projects] = PROJECTS;

  return (
    <div className={styles.root}>
      <header className={styles.hero}>
        <div className={styles.headingRow}>
          <h1 className={styles.title}>Наши проекты</h1>
          <p className={styles.intro}>
            Наши поставки для школьных дворов, городских площадок и спортивных комплексов.
          </p>
        </div>
      </header>

      <section className={styles.collection} aria-label="Реализованные проекты">
        {featured && <ProjectCard project={featured} featured />}
        <div className={styles.grid}>
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </section>

      <section className={styles.contact} aria-labelledby="project-contact-title">
        <div>
          <h2 className={styles.contactTitle} id="project-contact-title">
            Оборудование для вашей площадки
          </h2>
          <p className={styles.contactText}>
            Расскажите о месте установки и задачах — обсудим комплектацию и подготовим предложение.
          </p>
        </div>
        <Link className={styles.contactLink} to="/contacts">
          Обсудить проект
        </Link>
      </section>
    </div>
  );
};
